"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.putZone = void 0;
/**
 * Allows you to create a new zone or completely replace an existing zone
 */
var putZone = function (instance) {
    return function (body, config) {
        return instance.put("/catalogues/postcodes/zones/", body, config);
    };
};
exports.putZone = putZone;
